import Module from "./Module";
import TrainingList from "./views/TrainingList.vue";
import TrainingCreate from "./views/TrainingCreate";
import TrainingPilihJadwal from "./views/TrainingPilihJadwal";
import InformasiPendaftaran from "./views/InformasiDaftar";
import PendaftaranSuccess from "./views/PendaftaranSuccess";
import Pembayaran from "./views/Pembayaran";
import DetailPembayaran from "./views/DetailPembayaran";
import TrainingDetail from "./views/TrainingDetail.vue";
import SendReview from "./views/SendReview.vue";
import RiwayatList from "./views/RiwayatList.vue";
import TrainingRescedule from "./views/TrainingRescedule";
import DetailPayment from "./views/DetailPayment.vue";
import helpers from "../../helpers/helpers";

const requireAuth = { requireAuth: true };

const moduleRoute = {
  path: "/kampus",
  component: Module,
  children: [
    {
      path: "training",
      component: Module,
      children: [
        {
          path: "",
          name: "training.list",
          component: TrainingList,
          meta: {
            ...requireAuth,
          },
        },
        {
          path: "riwayatTraining",
          name: "training.riwayat",
          component: RiwayatList,
          meta: {
            ...requireAuth,
          },
        },
        {
          path: "create/:idjenis",
          name: "training.create",
          component: TrainingCreate,
          meta: {
            ...requireAuth,
          },
        },
        {
          path: "detailTraining/:idtraining",
          name: "detailTraining",
          component: TrainingDetail,
          meta: {
            ...requireAuth,
          },
        },
        {
          path: "beriUlasan/:idtraining",
          name: "beriUlasan",
          component: SendReview,
          meta: {
            ...requireAuth,
          },
        },
        {
          path: "resceduleJadwal/:idtraining/:idjenis",
          name: "resceduleJadwal",
          component: TrainingRescedule,
          meta: {
            ...requireAuth,
          },
        },
        {
          path: "detailPembayaran/:idtraining",
          name: "detailPembayaran",
          component: DetailPayment,
          meta: {
            ...requireAuth,
          },
        },
        {
          path: "create/:idjenis",
          name: "training.create",
          component: TrainingCreate,
          meta: {
            ...requireAuth,
          },
        },
        {
          path: "detail_jenis_training/:idjenis/:sesi",
          name: "training.pilihJadwal",
          component: TrainingPilihJadwal,
          meta: {
            ...requireAuth,
          },
        },
        {
          path: "informasi_pendaftaran/:idjenis",
          name: "informasi.pendaftaran",
          component: InformasiPendaftaran,
          meta: {
            ...requireAuth,
          },
        },
        {
          path: "pendaftaran_success/:idtraining`",
          name: "pendaftaran.success",
          component: PendaftaranSuccess,
          meta: {
            ...requireAuth,
          },
        },
        {
          path: "pembayaran_training/:idjenis",
          name: "pembayaran.training",
          component: Pembayaran,
          meta: {
            ...requireAuth,
          },
        },
        {
          path: "detail_pembayaran/:idTraining",
          name: "detail.pembayaran",
          component: DetailPembayaran,
          meta: {
            ...requireAuth,
          },
        },
      ],
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
